import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, StyledEngineProvider, ThemeProvider, useTheme } from '@mui/material';
import * as yup from 'yup';
import { useFormik } from 'formik';
import moment from 'moment';
import { DateRangePicker } from '@components';
export const DialogDateRange = ({ onClose, ...props }) => {
    const [dateRange, setDateRange] = React.useState({ startDate: moment().toDate(), endDate: moment().toDate() });
    const theme = useTheme();
    const form = useFormik({
        initialValues: {},
        validationSchema: yup.object({
            startDate: yup.date().typeError('Data/hora inválida').required('O campo é obrigatório'),
            endDate: yup.date().typeError('Data/hora inválida').required('O campo é obrigatório')
        }),
        validateOnMount: false,
        onSubmit: async (values) => {
            console.log(values);
            onClose(values);
        }
    });
    return (<StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Dialog {...props}>
          <form>
            <DialogTitle>{props.title}</DialogTitle>
            <DialogContent>
              <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                  <div className='App'>
                    <DateRangePicker open={true} initialDateRange={dateRange} onChange={range => setDateRange(range)}/>
                  </div>
                </ThemeProvider>
              </StyledEngineProvider>
            </DialogContent>
            <DialogActions>
              <Button type='button' onClick={() => onClose(undefined)}>
                Cancelar
              </Button>
              <Button onClick={() => {
            form.setFieldValue('startDate', dateRange.startDate);
            form.setFieldValue('endDate', dateRange.endDate);
            form.handleSubmit();
        }} disabled={!dateRange.startDate || !dateRange.endDate} variant='contained'>
                OK
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </ThemeProvider>
    </StyledEngineProvider>);
};
